import { POST_STATUS } from './post';
export const ENTITY_TYPE_POSTS = 'posts';
export const ENTITY_TYPE_MANAGE_POSTS_DRAFTS = `posts-${POST_STATUS.unpublished}`;
export const ENTITY_TYPE_MANAGE_POSTS_PUBLISHED = `posts-${POST_STATUS.published}`;
export const ENTITY_TYPE_MANAGE_POSTS_SCHEDULED = `posts-${POST_STATUS.scheduled}`;
export const ENTITY_TYPE_MANAGE_POSTS_TRASH = `posts-${POST_STATUS.deleted}`;
export const ENTITY_TYPE_MANAGE_POSTS_PENDING_REVIEW = `posts-${POST_STATUS.in_review}`;
export const ENTITY_TYPE_COMMENTS = 'comments';
export const POST_ENTITY_TYPES = [
    ENTITY_TYPE_POSTS,
    ENTITY_TYPE_MANAGE_POSTS_DRAFTS,
    ENTITY_TYPE_MANAGE_POSTS_PUBLISHED,
    ENTITY_TYPE_MANAGE_POSTS_SCHEDULED,
    ENTITY_TYPE_MANAGE_POSTS_TRASH,
    ENTITY_TYPE_MANAGE_POSTS_PENDING_REVIEW,
];
export const ALL_ENTITY_TYPES = [ENTITY_TYPE_COMMENTS, ...POST_ENTITY_TYPES];
//# sourceMappingURL=entity-types.js.map